/**
 * PartnerProgramsCtrl controller
 * Show all partnerPrograms
 */

/**
 * PartnerProgramsCtrl controller
 *
 * @class PartnerProgramsCtrl
 * @memberof mwApp/partnerPrograms
 * @see mwApp/partnerPrograms
 *
 * @ngdoc controller
 * @name mwApp/partnerPrograms.controller:PartnerProgramsCtrl
 */
/* @ngInject */
export default function PartnerProgramsCtrl ($scope, $uibModal, PartnerProgram, extra) {
  var vm = this
  vm.isFound = true

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Partner Programs list
   *
   * @memberof mwApp/partnerPrograms.controller:PartnerProgramsCtrl
   * @type {models.PartnerProgram[]}
   */
  vm.pp = []

  vm.partnerProviders = extra.allowedPartnerProviderTypes

  /**
   * Get Partner Programs from backend
   *
   * @memberof mwApp/partnerPrograms.controller:PartnerProgramsCtrl
   */
  vm.getPartnerPrograms = function () {
    PartnerProgram.loadAll()
      .then(
        data => {
          vm.pp = data
          vm.isFound = !!vm.pp.length
          $scope.loading = false
        }
      )
  }
  vm.getPartnerPrograms()

  /**
   * Create partner program
   *
   * @memberof mwApp/partnerPrograms.controller:PartnerProgramsCtrl
   * @function
   * @param  {models.PartnerProgram} pp
   */
  vm.addPP = vm.editPP = function (pp) {
    var isNew = !pp
    var initialPP = angular.copy(pp) // initial state
    $uibModal.open({
      templateUrl: 'components/partnerPrograms/views/addPartnerProgram.html',
      controller: 'AddPartnerProgramCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        pp: function () {
          return !isNew
            ? PartnerProgram.load({ id: pp.id })
            : new PartnerProgram()
        },
        partnerProviders: function () {
          const allowedPartnerProviderTypes = angular.copy(extra.allowedPartnerProviderTypes)
          if (isNew && vm.pp.some(p => p.partnerProvider === 'MAX')) delete allowedPartnerProviderTypes.MAX
          return allowedPartnerProviderTypes
        }
      }
    }).result
      .then(
        function close () {
          vm.getPartnerPrograms()
        },
        function dismiss () {
          if (!isNew) {
            angular.copy(initialPP, pp) // restore catchup
          }
        }
      )
  }

  /**
   * Delete Partner Program
   *
   * @memberof mwApp/partnerPrograms.controller:PartnerProgramsCtrl
   */
  vm.delete = function (program) {
    program._delete()
      .then(() => vm.getPartnerPrograms())
  }
}
